
const SignalsIcon = ({ color = "var(--primary-color)", width, height, ...props}) => (
    <svg    
        viewBox="0 0 20 20"
        width={width || 20}
        height={height || 20}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        {...props}
    >
        <path
        stroke={`${color}`}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity={0.72}
        strokeWidth={1.5}
        d="M10 11.215V8.1M10 13.72a.208.208 0 1 0 .002.417.208.208 0 0 0-.003-.418"
        />
        <path
        stroke={`${color}`}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity={0.72}
        strokeWidth={1.5}
        d="m11.69 3.731 6.383 11.17c.742 1.299-.196 2.914-1.69 2.914H3.616c-1.495 0-2.433-1.616-1.69-2.914l6.382-11.17c.748-1.309 2.634-1.309 3.382 0Z"
        clipRule="evenodd"
        />
    </svg>
)

export default SignalsIcon
